import React from "react";
import location from "../../assets/images/location.png";
import mail from "../../assets/images/mail.png";
import call from "../../assets/images/call.png";

const ContactList = () => {
  return (
    <div className="w-full flex flex-col mt-12 items-center justify-center z-0">
      <div className="grid w-full grid-cols-1 gap-5 justify-items-center px-4 py-6 sm:py-14 sm:px-20 jost-regular sm:grid-cols-2 lg:grid-cols-3">
        <div className="w-full min-w-80 lg:w-full h-64 border border-[#D9D9D9] rounded-lg flex items-center justify-center text-center flex-col hover:shadow-[0_0_20px_2px_rgba(0,0,0,0.1)] transition">
          <div className="w-20 h-20 rounded-full border-2 border-[#0D9447] mb-2 flex items-center justify-center">
            <img src={location} alt="location" />
          </div>
          <div className="font-medium text-2xl">Visit Our Office</div>
          <a
            href="/"
            className="text-gray-600 mt-4 hover:-translate-y-1 hover:scale-110 transition cursor-pointer"
          >
            71-75 Shelton Street Covent Garden
            <br />
            london WC2 9JQ U.K.
          </a>
        </div>
        <div className="w-full min-w-80 lg:w-full h-64 border border-[#D9D9D9] rounded-lg flex items-center justify-center text-center flex-col hover:shadow-[0_0_20px_2px_rgba(0,0,0,0.1)] transition">
          <div className="w-20 h-20 rounded-full border-2 border-[#0D9447] mb-2 flex items-center justify-center">
            <img src={mail} alt="mail" />
          </div>
          <div className="font-medium text-2xl">Drop Us a Line</div>
          <a
            href="mailto:laila.khan@psycheethos.com"
            className="text-gray-600 mt-4 hover:-translate-y-1 hover:scale-110 transition cursor-pointer"
          >
            laila.khan@psycheethos.com{" "}
          </a>
        </div>
        <div className="w-full min-w-80 lg:w-full h-64 border border-[#D9D9D9] rounded-lg flex items-center justify-center text-center flex-col hover:shadow-[0_0_20px_2px_rgba(0,0,0,0.1)] transition">
          <div className="w-20 h-20 rounded-full border-2 border-[#0D9447] mb-2 flex items-center justify-center">
            <img src={call} alt="call" />
          </div>
          <div className="font-medium text-2xl">Give us a call</div>
          <a
            href="tel:+44485543091"
            className="text-gray-600 mt-4 hover:-translate-y-1 hover:scale-110 transition cursor-pointer"
          >
            +44485543091
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactList;
